import type { JobNumberItem } from '../types';
import { JOB_NUMBER_MAX_LENGTH, JOB_NUMBER_PATTERN } from '../constants';
import { isDuplicateCommittedJobNumber } from './isDuplicateCommittedJobNumber';

/**
 * 仕事Noが登録可能かを検証し、不可ならユーザー提示用のエラーメッセージを返す（可なら null）。
 * jobNumber は trim 済み・非空であることを前提とする。
 */
export const validateJobNumber = (rows: JobNumberItem[], excludeId: string, jobNumber: string): string | null => {
  if (!JOB_NUMBER_PATTERN.test(jobNumber)) {
    return '仕事Noは英数字とハイフンのみ使用できます';
  }
  // UI 側でも maxLength で制限しているが、バックエンドの max(255) との整合をここでも強制する
  if (jobNumber.length > JOB_NUMBER_MAX_LENGTH) {
    return `仕事Noは${String(JOB_NUMBER_MAX_LENGTH)}文字以内で入力してください`;
  }
  // 編集中の行同士の重複はここでは検知しない。同値の同時コミットはバックエンドの
  // 一意制約（job_number UNIQUE → 409）が2件目を弾き、エラーメッセージ表示で帰結する。
  if (isDuplicateCommittedJobNumber(rows, excludeId, jobNumber)) {
    return `仕事No「${jobNumber}」は既に登録されています`;
  }
  return null;
};
